<template>
  <v-app id="app" dark>
    <nav-bar></nav-bar>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <router-view/>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import NavBar from '@/components/NavBar'
export default {
  components: {
    NavBar
  }
}
</script>
<style lang="stylus">
@import './assets/style/main'
</style>
